import storeConfig from './store/store-config';
import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex)

const store =  new Vuex.Store(storeConfig)

export default store